module.exports = __webpack_public_path__ + "static/media/trevorMoore.598f5289.png";